import { h } from '@stencil/core';
import { EQdsButtonImportance, EQdsButtonSize, isAnalyticsEnabled, externalLinkHandler } from '@pes-ui/utils';
import sanitize from 'sanitize-html';
import { EnvironmentTooltip } from '../environmental-data/Tooltip';
export const EnvironmentTableCell = (characteristic) => {
  const { labelText, tooltip, externalUrl, image, textAfter } = characteristic || {};
  if (!labelText)
    return null;
  const { url, absoluteUrl, alt } = image || {};
  return h("div", { class: 'envsection-cell-container' }, image && h("img", { class: "envsection_cell-imgLogo", src: url || absoluteUrl, alt: alt }), h("div", { class: "envsection_cell-link-block" }, h("div", { class: "envsection_cell-label-tooltip" }, externalUrl && labelText
    && h("qds-standalone-link", { size: EQdsButtonSize.STANDARD, importance: EQdsButtonImportance.STANDARD, target: "_blank", onClick: () => {
        isAnalyticsEnabled() && externalLinkHandler(externalUrl);
      }, class: "envsection_cell-link", href: externalUrl }, labelText), !externalUrl && labelText, tooltip && h(EnvironmentTooltip, { text: tooltip })), textAfter && (h("div", { class: "envsection_cell-text-after", innerHTML: sanitize(textAfter) }))));
};
